//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    options: {required: true, type: Array},
    value: {required: true, type: Array},
    iconpattern: String,
    align: String
  },
  data() {
    return {
      isShowDetail: false,
      currentValue: []
    };
  },
  watch: {
    value(val) {
      this.currentValue = val.slice(0, this.value.length);
    }
  },
  computed: {
    listData() {
      if (this.value.length === 0 || this.options.length === 0) {
        return [];
      }
      return this.options.filter(item => {
        return this.value.indexOf(item.id.toString()) > -1;
      }).map(item => {
        return {
          label: item.name,
          value: item.id
        };
      });
    },
    listHeight () {

      return document.documentElement.clientHeight*0.8-44
    }
  },
  methods: {
    handleCancel() {
      this.currentValue = JSON.parse(JSON.stringify(this.value));
      this.isShowDetail = false;
      setTimeout(_ => {
      });
    },
    handleClickListConfirm() {
      this.$emit('input', this.currentValue);
      this.isShowDetail = false;
    },
    handleConfirm() {
      this.$emit('confirm-click');
    }
  },
  created() {
    this.currentValue = this.value.slice(0, this.value.length);
  }
};



// WEBPACK FOOTER //
// ./packages/select/src/selected-footer.vue